import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({
  spacing,
  palette
}) => ({
  container: {
    padding: `${spacing(0.75)}px ${spacing(2)}px`,
    borderBottom: `1px solid ${palette.grey[200]}`
  }
}));
